<template>
    <v-content>

        <v-card class="elevation-12">
            <v-toolbar
                color="primary"
                dark
                flat
            >
                <v-toolbar-title>Login</v-toolbar-title>
                <v-spacer />
            </v-toolbar>

            <v-card-text>
                
                <!-- Form -->
                <v-form
                    ref="loginForm"
                    v-model="loginValid"
                    
                >
                    <!-- Login field :rules="emailRules" -->
                    <v-text-field
                        v-model="login"
                        solo flat
                        background-color="blue-grey lighten-5"
                        label="Login (email)"
                        name="login"
                        prepend-icon="mdi-account"
                        type="text"
                        :rules="emailRules"
                        validate-on-blur
                    />
                    
                    <!-- Password field -->
                    <v-text-field
                        v-model="password"
                        solo flat
                        background-color="blue-grey lighten-5"
                        id="password"
                        label="Password"
                        name="password"
                        prepend-icon="mdi-lock"
                        type="password"
                        :rules="passwordRules"
                        validate-on-blur
                    />
                </v-form>
                
            </v-card-text>
            
            <v-container class="mt-n12 pt-n12">
                
                <v-card-actions>

                    <v-subheader class="text-left d-flex ml-4 mt-0 pt-2 red--text">{{loginErrorText}}</v-subheader>

                    <v-spacer />
                    
                    <!-- <v-spacer /> -->
                    <v-btn
                        class="d-flex mt-0 pt-0"
                        color="primary"
                        @click="submit"
                        :loading="loginInProgress"
                        :disabled="loginInProgress"
                    >
                    Login</v-btn>
                </v-card-actions>

            </v-container>

        </v-card>
        
    </v-content>
</template>

<script>

// ----------------------------------------------------
//
//  Main script
//
// ----------------------------------------------------

import fb from '@/shift/fb';


export default
{
    name: 'Login',

    // ----------------------------------
    //	Data
    // ----------------------------------

    data: () =>
	({
        loginValid: true,
        loginErrorText: '',
        loginInProgress: false,

        // Login (email)
        login: '',

        emailRules:
        [
            v => !!v || 'Login requires an email address',
            v => /.+@.+\..+/.test(v) || 'Login requires an email address',
        ],

        password: '',

        passwordRules:
        [
            v => !!v || 'Password is too short',
            v => (v && v.length > 3) || 'Password is too short',
        ],

    }),

    props:
    {
        source: String,
    },

    create()
    {
        fb;
        
    },

    // ----------------------------------
	//	Methods
	// ----------------------------------

	methods:
	{
        validate()
        {
            return this.$refs.loginForm.validate();
        },

        /* reset()
        {
            this.$refs.loginForm.reset();
        },

        resetValidation()
        {
            this.$refs.loginForm.resetValidation();
        }, */

        submit()
        {
            console.log(this.password);
            if (this.validate())
            {
                this.loginInProgress = true;

                fb.auth.signInWithEmailAndPassword(this.login, this.password)
                .then(cred =>
                {
                    console.log(cred);
                    this.loginInProgress = false;

                    this.$router.push('/');
                })
                .catch(er =>
                {
                    this.loginInProgress = false;

                    if (er.code == "auth/user-not-found")
                    {
                        this.loginErrorText = "Error: User not found";
                    }
                    else if (er.code == "auth/wrong-password")
                    {
                        this.loginErrorText = "Error: Password incorrect";
                    }
                    else
                    {
                        this.loginErrorText = er.message;
                    }
                    console.log("* Error", er);
                });

                
            }
        },
    }

}
</script>